module.exports = __webpack_public_path__ + "img/orange-clock.ff2f6c88.svg";